import { styled } from '@mui/material';
import { Image } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const FooterStyled = styled('div')`
  padding-top: 20px;
  padding-bottom: 10px;
`;

export const GuaranteeStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
`;

export const GuaranteeIconStyled = styled(Icon)`
  margin-right: 5px;
  fill: ${({ theme }) => theme.palette.success.main};
`;

export const BrandsImageStyled = styled(Image)`
  display: block;
  width: 75%;
  margin-right: auto;
  margin-bottom: 30px;
  margin-left: auto;
`;
